import api from "./api";

const medicalServicesOverrideService = {};
const endpoint = "/medical-services-overrides";

medicalServicesOverrideService.getByDoctor = function (doctorId) {
  return api.get(`${endpoint}/doctor/${doctorId}`).then((res) => res.data);
};

medicalServicesOverrideService.createOrUpdate = function (
  doctor,
  medicalServices
) {
  return api
    .post(endpoint, { doctor, medicalServices })
    .then((res) => res.data);
};

medicalServicesOverrideService.delete = function (id) {
  return api.delete(`${endpoint}/${id}`).then((res) => res.data);
};

export default medicalServicesOverrideService;
